<template>
  <el-dialog title="查看详情" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap"></div>
  </el-dialog>
</template>
<script>
export default {
  name: "customDetailDialog",
  props: ["visible"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      dialogVisible: this.visible
    };
  }
};
</script>

